/**
 * Reklam hesabı bağlama — dönüş adresinin ERKEN temizlenmesi (v3.1 K3; docs/security/v3-oauth-gunluk-guvenligi.md).
 *
 * Sağlayıcı kullanıcıyı `…/settings/connections/ads/callback?code=…&state=…` adresine TAM sayfa yüklemesiyle döndürür. Dönüş
 * sayfası tembel yüklenen bir parçadır ve ondan ÖNCE oturum denetimi (`/auth/me`), kabuk (bildirimler, plan, hesap durumu) ve
 * parça isteği çalışır: adres yalnız sayfa bileşeninde temizlenseydi bu isteklerin hepsi yetki kodu adres çubuğundayken
 * gönderilirdi (`Referer`'a ve tarayıcı geçmişine açık). Bu yüzden sorgu, uygulama çizilmeden ÖNCE — ilk API çağrısından önce —
 * belleğe alınır ve adres çubuğundan + tarayıcı geçmişinden silinir (geçmiş kaydı DEĞİŞTİRİLİR, yeni kayıt eklenmez).
 *
 * Değer yalnız bu modülün belleğindedir: yerel depoya, çereze, günlüğe ya da hata iletisine yazılmaz; dönüş sayfası bir kez
 * okur ve siler. Sayfa yenilenirse değer kaybolur (kod ve durum değeri zaten tek kullanımlıktır; bağlama yeniden başlatılır).
 * Asıl önlem sunucudadır (`Referrer-Policy: no-referrer` + günlük biçimleri); bu modül adresin tarayıcıda kaldığı süreyi
 * sıfıra indirir.
 */
import { AD_CONNECT_CALLBACK_PATH } from '@castinflow/shared';

let captured: string | null = null;

/**
 * Uygulama çizilmeden önce bir kez çağrılır (`main.tsx`). Dönüş yolunda değilse ya da adres sorgu / parça taşımıyorsa hiçbir
 * şey yapmaz. Parça da silinir (bazı sağlayıcılar yönlendirme adresine `#_=_` ekler).
 */
export function captureAdConnectReturn(win: Pick<Window, 'location' | 'history'> = window): void {
  const { pathname, search, hash } = win.location;
  if (pathname.replace(/\/+$/, '') !== AD_CONNECT_CALLBACK_PATH) return;
  if (search === '' && hash === '') return;
  captured = search;
  win.history.replaceState(win.history.state, '', AD_CONNECT_CALLBACK_PATH);
}

/**
 * Yakalanan sorgu dizgisi (yoksa `null`). Okumak silmez: geliştirme kipinde bileşenin ilk durumu iki kez hesaplanır ve ikisi de
 * aynı değeri görmelidir. Sayfa değeri kendi durumuna aldıktan sonra `clearAdConnectReturn` çağırır.
 */
export function capturedAdConnectReturn(): string | null {
  return captured;
}

/** Değer sayfanın durumuna alındı: modül belleğinden silinir */
export function clearAdConnectReturn(): void {
  captured = null;
}
